import React from 'react'

import { Container, Row, Col } from '../../components/Bootstrap'
import Panel from '../../components/Panel'

const Approach  = () => (
	<Panel colour="#ffffff">
		<Container>
			<h2>Approach to Strategic Plan Renewal</h2>
			<Row className="justify-content-center">
				<Col md="8">
					<ul>
						<li>CILT serves consumers in the Greater Toronto area and region, and in all of Ontario for the delivery of the Direct Funding Program and the Student Attendant Service Fund. The primary disability addressed is physical including both visible and invisible disabilities, mobility, sensory and communication barriers. </li>
						<li>
							The process for the strategic plan renewal started with a Communication and Engagement plan that included:
							<ul>
								<li>Engagement in person with 30 CILT staff, 7 community partners providing Attendant Services; 1 funder and Board Strategic Planning Committee (4 members); 2 sessions with CILT’s Board and 1 session with consumers at North Yorkers for the Disabled</li>
								<li>Environmental scan through a survey that explored the CILT’s Strengths, Weaknesses, Opportunities and Threats (SWOT analysis) – 65 respondent</li>
								<li>Facilitated conversations at People in Motion to understand needs of youths (10 youths)</li>
							</ul>
						</li>
					</ul>
				</Col>
			</Row>
		</Container>
	</Panel>
)

export default Approach